import { MoneyInput, Modal, parseMoneyInputValue } from '@/components/common';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  LinearProgress,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import * as zod from 'zod';
import { ModalTitle } from '../common/Modal/common/ModalTitle';

const openCashSessionSchema = zod.object({
  startingCash: zod
    .number({
      required_error: 'Informe o valor inicial',
      invalid_type_error: 'Informe um valor inicial válido',
    })
    .min(0, 'Informe um valor maior ou igual a zero'),
});

export type OpenCashSessionFormData = zod.infer<typeof openCashSessionSchema>;

type OpenCashSessionModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: OpenCashSessionFormData) => void;
};

export function OpenCashSessionModal({
  isOpen,
  isLoading,
  onClose,
  onSubmit,
}: OpenCashSessionModalProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<OpenCashSessionFormData>({
    resolver: zodResolver(openCashSessionSchema),
    defaultValues: { startingCash: 0 },
  });

  return (
    <Modal open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
      {isLoading ? <LinearProgress /> : null}
      <ModalTitle title="Abrir Caixa" onClose={onClose} />
      <DialogContent dividers>
        <Box
          component="form"
          id="open-cash-session-form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            name="startingCash"
            control={control}
            render={({ field }) => (
              <MoneyInput
                {...field}
                fullWidth
                label="Valor inicial"
                error={!!errors.startingCash}
                helperText={errors.startingCash?.message}
                onChange={({ target }) =>
                  field.onChange(parseMoneyInputValue(target.value))
                }
              />
            )}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3 }}>
        <Button disabled={isLoading} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          type="submit"
          form="open-cash-session-form"
          disabled={isLoading}
          variant="contained"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Modal>
  );
}
